import * as React from "react";
import {useTranslation} from "react-i18next";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";

interface ISummaryShippingOptionProps {
  goToShippingView: () => void;
}

const SummaryShippingOption: React.FC<ISummaryShippingOptionProps> = (props) => {
  const {t} = useTranslation("checkout");
  const {checkout} = useCheckoutContext();
  const {goToShippingView} = props;

  const shippingLine = checkout.cartData.positions.find((pos) => {
    return pos.type === "Shipping" && pos.isValid;
  });

  let OptionRow: React.FC;
  if (!(shippingLine && shippingLine.reference)) {
    OptionRow = () => (
      <div className="error-block-main">{t("Sie haben keine oder eine ungültige Versandart ausgewählt.")}</div>
    );
  } else {
    const logisticsTypeId = shippingLine.reference.shippingClassId;
    const key = `shipping${logisticsTypeId}`;

    OptionRow = () => (
      <div key={"" + logisticsTypeId} className="SimpleRadioList__Row">
        <label htmlFor={key}>
          <div className="SimpleRadioList__Row__Radio">
            <input type="radio" name="LogisticsTypeId" id={key} checked={true} readOnly={true} />
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: shippingLine.text,
            }}
          />
        </label>
      </div>
    );
  }

  return (
    <>
      <h2>{t("Versandoptionen")}</h2>
      <span className="Pen" onClick={goToShippingView}>
        <span className="Svg Svg-Icon-Pen">&#160;</span>
      </span>
      <div className={`SimpleRadioList${shippingLine && shippingLine.reference ? " ArrowBorder" : ""}`}>
        <OptionRow />
      </div>
    </>
  );
};

export default SummaryShippingOption;
